import {
  SET_CC_CANDIDATES,
  SET_CC_PRIMARY,
  TOGGLE_CC_COMPARISON,
  RESET_CC,
  CandidatesComparisonState,
  CandidatesComparisonActions
} from "../types/candidatesComparison";

const initialState: CandidatesComparisonState = {
  primaryCandidateId: null,
  comparisonCandidateIds: [],
  candidates: []
};

export const candidatesComparisonReducer = (
  state = initialState,
  action: CandidatesComparisonActions
): CandidatesComparisonState => {
  switch (action.type) {
    case SET_CC_CANDIDATES:
      return { ...state, candidates: action.payload };
    case SET_CC_PRIMARY:
      return {
        ...state,
        primaryCandidateId: action.payload,
        comparisonCandidateIds: []
      };
    case TOGGLE_CC_COMPARISON:
      if (state.comparisonCandidateIds.includes(action.payload)) {
        return {
          ...state,
            comparisonCandidateIds: state.comparisonCandidateIds.filter(id => id !== action.payload)
        };
      }
      if (state.comparisonCandidateIds.length >= 4) return state;
      return {
        ...state,
        comparisonCandidateIds: [...state.comparisonCandidateIds, action.payload]
      };
    case RESET_CC:
      return initialState;
    default:
      return state;
  }
};